import { useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectStripeSubscribeSessionState } from '@client/model/selectors';
import { resetStripeSubscribeSession } from '@client/model/stripeSubscribeSessionModel';
import {
  CheckoutLayout,
  CHECKOUT_PLAN_CONTENT,
  formatTrialDetail,
  type CheckoutPlanType,
} from '@client/features/advisor-onboarding';
import { analytics } from '@shared/posthog/analytics';

const VALID_PLAN_TYPES: CheckoutPlanType[] = ['monthly', 'annual'];

export function AdvisorCheckoutPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { advisorId } = useParams<{ advisorId: string }>();
  const { clientSecret, isLoading } = useSelector(selectStripeSubscribeSessionState);
  const [searchParams] = useSearchParams();
  const planParam = searchParams.get('plan');
  const planType: CheckoutPlanType =
    planParam && VALID_PLAN_TYPES.includes(planParam as CheckoutPlanType)
      ? (planParam as CheckoutPlanType)
      : 'monthly';
  const content = CHECKOUT_PLAN_CONTENT[planType];
  const checkoutViewedCaptured = useRef(false);
  if (!checkoutViewedCaptured.current && advisorId) {
    checkoutViewedCaptured.current = true;
    analytics.advisor.checkoutViewed({ advisorId, planType });
  }

  const trialDetailFormatted = content.hasTrial
    ? formatTrialDetail(content.trialDetail, content.trialDays)
    : null;

  const handleBack = () => {
    dispatch(resetStripeSubscribeSession());
    navigate(`/advisors/${advisorId}/onboarding/activate-seat`);
  };

  return (
    <CheckoutLayout
      content={content}
      trialDetailFormatted={trialDetailFormatted}
      onBack={handleBack}
      isLoading={isLoading}
      clientSecret={clientSecret ?? null}
    />
  );
}
